import React from 'react';
import styles from './formLayout.module.scss';
import LineSeparator from '../../Form/LineSeparator/LineSeparator';

export type Variant = 'profile' | 'security' | 'default';

interface FormLayoutProps extends React.DetailedHTMLProps<
  React.FormHTMLAttributes<HTMLFormElement>,
  HTMLFormElement
> {
  formTitle?: string;
  variant?: Variant;
  messageRequired?: boolean;
  showRequiredText?: boolean;
}

const theme = (variant: Variant): string => {
  switch (variant) {
    case 'profile':
      return styles.isProfile;
    case 'security':
      return styles.isSecurity;
    case 'default':
      return '';
  }
};

const FormLayout: React.FC<FormLayoutProps> = ({
  variant = 'default',
  formTitle,
  children,
  messageRequired,
  ...props
}) => (
  <section className={`${styles.root} ${theme(variant)}`}>
    {formTitle ? <h2 className={styles.formTitle}>{formTitle}</h2> : null}
    <LineSeparator />
    {messageRequired === undefined ||
      (messageRequired && (
        <div className={styles.description}>
          Els camps marcats amb asterisc (
          <span className={styles.asterisc}>*</span>) són obligatoris:
        </div>
      ))}
    <form className={styles.form} {...props}>
      {children}
    </form>
  </section>
);

export default FormLayout;
